import React, { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://link.msgsndr.com/js/form_embed.js";
const WIDGET_ID = "azTU883MoCHioquGkmVx";
const WIDGET_URL = `https://api.leadconnectorhq.com/widget/booking/${WIDGET_ID}`;

/** LeadConnector booking widget with auto-resize script. */
const BookingWidget = () => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.type = "text/javascript";
    document.body.appendChild(s);
  }, []);

  return (
    <div
      ref={wrapperRef}
      data-testid="booking-widget"
      className="w-full bg-[var(--lt-peace)] overflow-hidden"
      style={{ minHeight: 760 }}
    >
      <iframe
        src={WIDGET_URL}
        id={`${WIDGET_ID}_${Date.now()}`}
        title="Book a discovery call"
        scrolling="no"
        style={{ width: "100%", minHeight: 760, border: 0, overflow: "hidden", display: "block" }}
      />
    </div>
  );
};

export default BookingWidget;
